var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTxt = function SvgTxt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.5 10.5 18 6h4.5zM4.5 13h13.6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 9,
    x: 2.1,
    y: 11,
    fill: "#C91E08",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.99 14.197V13.5h3.286v.697H7.05V17.5h-.836v-3.303zm4.785-.697.806 1.363h.032l.81-1.363h.955l-1.22 2 1.248 2h-.973l-.82-1.365h-.032l-.82 1.365h-.969l1.252-2-1.228-2zm3.151.697V13.5h3.285v.697h-1.224V17.5h-.836v-3.303z"
  })));
};
export default SvgTxt;